import { render } from "./ActionIcon.vue?vue&type=template&id=7ccc5fb4"
import script from "./ActionIcon.vue?vue&type=script&lang=js"
export * from "./ActionIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"static/js/components-wa/content/ActionIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7ccc5fb4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7ccc5fb4', __exports__)) {
    api.reload('7ccc5fb4', __exports__)
  }
  
  module.hot.accept("./ActionIcon.vue?vue&type=template&id=7ccc5fb4", () => {
    api.rerender('7ccc5fb4', render)
  })

}


export default __exports__